module.exports = __webpack_public_path__ + "img/si_white.54dc1d58.svg";